import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PositionTable = _resolveComponent("PositionTable")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(_component_PositionTable, {
        items: _ctx.positions,
        onOnDeleteButtonClick: _ctx.onDeleteButtonClickedHandler
      }, null, 8, ["items", "onOnDeleteButtonClick"])
    ]),
    _: 1
  }))
}